export interface Product {
  id: string;
  name: string;
  category: "dzi" | "crystal" | "jade" | "thangka";
  subcategory: string;
  desc: string;
  detail: string;
  price: number;
  tag?: string;
  badge?: string;
  img: string;
}

export const products: Product[] = [
  // ── 西藏天珠 ──
  {
    id: "dzi-001",
    name: "九眼天珠手鍊",
    category: "dzi",
    subcategory: "九眼天珠",
    desc: "至尊守護，財富智慧",
    detail: "九眼天珠象徵至尊能量，寓意財富、智慧與貴人相助，為天珠中最具代表性的守護之珠。",
    price: 12800,
    tag: "人氣首選",
    badge: "熱銷",
    img: "https://readdy.ai/api/search-image?query=nine%20eye%20Tibetan%20dzi%20bead%20bracelet%20on%20white%20marble%20luxury%20jewelry%20product%20photography%20warm%20golden%20light%20elegant%20minimalist%20high%20detail%20texture%20close%20up&width=500&height=500&seq=p_dzi001&orientation=squarish",
  },
  {
    id: "dzi-002",
    name: "三眼天珠手鍊",
    category: "dzi",
    subcategory: "三眼天珠",
    desc: "福祿壽三大能量",
    detail: "三眼天珠代表福、祿、壽三大能量，象徵事業、財富與健康，是最受歡迎的吉祥天珠之一。",
    price: 8600,
    tag: "熱銷推薦",
    img: "https://readdy.ai/api/search-image?query=three%20eye%20Tibetan%20dzi%20bead%20bracelet%20on%20cream%20marble%20luxury%20jewelry%20product%20photography%20warm%20light%20elegant%20minimalist%20high%20detail%20texture&width=500&height=500&seq=p_dzi002&orientation=squarish",
  },
  {
    id: "dzi-003",
    name: "虎牙天珠手鍊",
    category: "dzi",
    subcategory: "虎牙天珠",
    desc: "勇氣守護，化解負能量",
    detail: "虎牙天珠象徵勇氣與守護，被認為具有化解負能量的寓意，為勇者的護身符。",
    price: 7200,
    img: "https://readdy.ai/api/search-image?query=tiger%20tooth%20Tibetan%20dzi%20bead%20bracelet%20on%20stone%20surface%20luxury%20jewelry%20product%20photography%20natural%20light%20elegant%20minimalist%20high%20detail%20texture&width=500&height=500&seq=p_dzi003&orientation=squarish",
  },
  {
    id: "dzi-004",
    name: "蓮花天珠吊墜",
    category: "dzi",
    subcategory: "蓮花天珠",
    desc: "純潔心靈，智慧開悟",
    detail: "蓮花天珠象徵純潔與智慧，蓮花出淤泥而不染，寓意心靈的純淨與精神的昇華。",
    price: 9500,
    tag: "精品典藏",
    img: "https://readdy.ai/api/search-image?query=lotus%20pattern%20Tibetan%20dzi%20bead%20pendant%20necklace%20on%20white%20marble%20luxury%20jewelry%20product%20photography%20soft%20warm%20light%20elegant%20minimalist%20high%20detail&width=500&height=500&seq=p_dzi004&orientation=squarish",
  },
  {
    id: "dzi-005",
    name: "財神天珠手鍊",
    category: "dzi",
    subcategory: "財神天珠",
    desc: "招財旺運，事業亨通",
    detail: "財神天珠以特殊紋路象徵財富流入，是許多事業人士的首選守護飾品。",
    price: 11200,
    badge: "新品",
    img: "https://readdy.ai/api/search-image?query=wealth%20pattern%20Tibetan%20dzi%20bead%20bracelet%20on%20golden%20marble%20luxury%20jewelry%20product%20photography%20warm%20golden%20light%20elegant%20minimalist%20high%20detail&width=500&height=500&seq=p_dzi005&orientation=squarish",
  },
  {
    id: "dzi-006",
    name: "天地天珠套組",
    category: "dzi",
    subcategory: "天地天珠",
    desc: "天地能量，陰陽平衡",
    detail: "天地天珠成對呈現，象徵天地陰陽的平衡與和諧，是送禮自用的絕佳選擇。",
    price: 18800,
    tag: "限量典藏",
    img: "https://readdy.ai/api/search-image?query=pair%20Tibetan%20dzi%20bead%20bracelet%20set%20on%20dark%20stone%20luxury%20jewelry%20product%20photography%20warm%20atmospheric%20light%20elegant%20minimalist%20high%20detail%20texture&width=500&height=500&seq=p_dzi006&orientation=squarish",
  },

  // ── 天然水晶礦石 ──
  {
    id: "crystal-001",
    name: "天然紫水晶手鍊",
    category: "crystal",
    subcategory: "紫水晶",
    desc: "智慧靈性，平靜安定",
    detail: "紫水晶象徵智慧、靈性與直覺，有助於提升思維清晰度，帶來平靜與內在平衡。",
    price: 3600,
    tag: "熱銷推薦",
    badge: "熱銷",
    img: "https://readdy.ai/api/search-image?query=amethyst%20purple%20crystal%20bracelet%20on%20white%20marble%20luxury%20jewelry%20product%20photography%20soft%20purple%20light%20elegant%20minimalist%20high%20detail%20texture&width=500&height=500&seq=p_cry001&orientation=squarish",
  },
  {
    id: "crystal-002",
    name: "白水晶淨化手鍊",
    category: "crystal",
    subcategory: "白水晶",
    desc: "淨化能量，清澈透明",
    detail: "白水晶被稱為「能量之王」，具有淨化、放大與平衡能量的特質，是最萬用的水晶之一。",
    price: 2800,
    img: "https://readdy.ai/api/search-image?query=clear%20white%20quartz%20crystal%20bracelet%20on%20white%20marble%20luxury%20jewelry%20product%20photography%20soft%20white%20light%20elegant%20minimalist%20high%20detail%20transparent&width=500&height=500&seq=p_cry002&orientation=squarish",
  },
  {
    id: "crystal-003",
    name: "黑曜石守護手鍊",
    category: "crystal",
    subcategory: "黑曜石",
    desc: "強力守護，吸收負能量",
    detail: "黑曜石是強力的守護石，能夠吸收並轉化負能量，為佩戴者建立能量防護屏障。",
    price: 2400,
    img: "https://readdy.ai/api/search-image?query=black%20obsidian%20bracelet%20on%20white%20marble%20luxury%20jewelry%20product%20photography%20soft%20neutral%20light%20elegant%20minimalist%20high%20detail%20glossy%20texture&width=500&height=500&seq=p_cry003&orientation=squarish",
  },
  {
    id: "crystal-004",
    name: "金髮晶招財手鍊",
    category: "crystal",
    subcategory: "金髮晶",
    desc: "財富事業，正能量滿滿",
    detail: "金髮晶內含金色髮絲般的金紅石，象徵財富、事業與正能量，是招財旺運的首選水晶。",
    price: 5800,
    tag: "精品典藏",
    img: "https://readdy.ai/api/search-image?query=golden%20rutilated%20quartz%20crystal%20bracelet%20on%20white%20marble%20luxury%20jewelry%20product%20photography%20warm%20golden%20light%20elegant%20minimalist%20high%20detail%20needle%20inclusions&width=500&height=500&seq=p_cry004&orientation=squarish",
  },
  {
    id: "crystal-005",
    name: "粉水晶愛情手鍊",
    category: "crystal",
    subcategory: "粉水晶",
    desc: "愛情桃花，溫柔守護",
    detail: "粉水晶象徵愛情、溫柔與自我療癒，有助於吸引愛情能量，增進人際關係的和諧。",
    price: 3200,
    badge: "新品",
    img: "https://readdy.ai/api/search-image?query=rose%20quartz%20pink%20crystal%20bracelet%20on%20white%20marble%20luxury%20jewelry%20product%20photography%20soft%20pink%20light%20elegant%20minimalist%20high%20detail%20texture&width=500&height=500&seq=p_cry005&orientation=squarish",
  },
  {
    id: "crystal-006",
    name: "碧璽能量手鍊",
    category: "crystal",
    subcategory: "碧璽",
    desc: "多彩能量，全方位守護",
    detail: "碧璽色彩豐富，每種顏色對應不同的能量頻率，是能量飾品中最具多樣性的礦石之一。",
    price: 6800,
    tag: "限量典藏",
    img: "https://readdy.ai/api/search-image?query=tourmaline%20colorful%20crystal%20bracelet%20on%20white%20marble%20luxury%20jewelry%20product%20photography%20soft%20colorful%20light%20elegant%20minimalist%20high%20detail%20texture&width=500&height=500&seq=p_cry006&orientation=squarish",
  },

  // ── 翡翠玉石 ──
  {
    id: "jade-001",
    name: "翡翠平安扣吊墜",
    category: "jade",
    subcategory: "平安扣",
    desc: "平安吉祥，圓滿守護",
    detail: "平安扣是最經典的玉石造型，圓形象徵圓滿與平安，是送禮自用的最佳選擇。",
    price: 8500,
    tag: "人氣首選",
    badge: "熱銷",
    img: "https://readdy.ai/api/search-image?query=jade%20jadeite%20green%20peace%20buckle%20pendant%20on%20white%20marble%20luxury%20jewelry%20product%20photography%20soft%20natural%20light%20elegant%20oriental%20minimalist%20high%20detail&width=500&height=500&seq=p_jade001&orientation=squarish",
  },
  {
    id: "jade-002",
    name: "翡翠手鐲",
    category: "jade",
    subcategory: "手鐲",
    desc: "溫潤典雅，東方美學",
    detail: "翡翠手鐲是東方女性最傳統的飾品之一，溫潤的質感與光澤展現含蓄的東方美學。",
    price: 28000,
    tag: "精品典藏",
    img: "https://readdy.ai/api/search-image?query=jade%20jadeite%20green%20bangle%20bracelet%20on%20white%20marble%20luxury%20jewelry%20product%20photography%20soft%20natural%20light%20elegant%20oriental%20minimalist%20high%20detail%20texture&width=500&height=500&seq=p_jade002&orientation=squarish",
  },
  {
    id: "jade-003",
    name: "翡翠觀音吊墜",
    category: "jade",
    subcategory: "觀音",
    desc: "慈悲守護，心靈安定",
    detail: "觀音是慈悲與守護的象徵，翡翠觀音吊墜融合了宗教信仰與藝術美感，是心靈守護的最佳選擇。",
    price: 15800,
    img: "https://readdy.ai/api/search-image?query=jade%20jadeite%20green%20Guanyin%20Buddha%20pendant%20on%20white%20marble%20luxury%20jewelry%20product%20photography%20soft%20natural%20light%20elegant%20oriental%20minimalist%20high%20detail&width=500&height=500&seq=p_jade003&orientation=squarish",
  },
  {
    id: "jade-004",
    name: "白玉如意吊墜",
    category: "jade",
    subcategory: "如意",
    desc: "萬事如意，吉祥圓滿",
    detail: "如意是中國傳統吉祥物，象徵萬事如意、心想事成，白玉的溫潤質感更添典雅氣質。",
    price: 12600,
    badge: "新品",
    img: "https://readdy.ai/api/search-image?query=white%20jade%20ruyi%20scepter%20pendant%20on%20white%20marble%20luxury%20jewelry%20product%20photography%20soft%20natural%20light%20elegant%20oriental%20minimalist%20high%20detail%20texture&width=500&height=500&seq=p_jade004&orientation=squarish",
  },
  {
    id: "jade-005",
    name: "翡翠葉形吊墜",
    category: "jade",
    subcategory: "葉形",
    desc: "生機盎然，事業蓬勃",
    detail: "葉形玉石象徵生命力與事業的蓬勃發展，翠綠的色澤充滿生機與活力。",
    price: 6800,
    img: "https://readdy.ai/api/search-image?query=jade%20jadeite%20green%20leaf%20pendant%20on%20white%20marble%20luxury%20jewelry%20product%20photography%20soft%20natural%20light%20elegant%20oriental%20minimalist%20high%20detail&width=500&height=500&seq=p_jade005&orientation=squarish",
  },
  {
    id: "jade-006",
    name: "翡翠珠鍊",
    category: "jade",
    subcategory: "珠鍊",
    desc: "圓潤飽滿，貴氣典雅",
    detail: "翡翠珠鍊以多顆圓潤翡翠珠串成，每一顆都精心挑選，色澤均勻，是高貴典雅的代表。",
    price: 45000,
    tag: "限量典藏",
    img: "https://readdy.ai/api/search-image?query=jade%20jadeite%20green%20bead%20necklace%20on%20white%20marble%20luxury%20jewelry%20product%20photography%20soft%20natural%20light%20elegant%20oriental%20minimalist%20high%20detail%20texture&width=500&height=500&seq=p_jade006&orientation=squarish",
  },

  // ── 唐卡佛牌 ──
  {
    id: "thangka-001",
    name: "手繪唐卡 — 綠度母",
    category: "thangka",
    subcategory: "唐卡",
    desc: "慈悲守護，消災解厄",
    detail: "綠度母是藏傳佛教中最重要的女性菩薩之一，象徵慈悲、守護與解脫，手繪唐卡具有極高的藝術與收藏價值。",
    price: 18800,
    tag: "精品典藏",
    badge: "熱銷",
    img: "https://readdy.ai/api/search-image?query=Tibetan%20thangka%20painting%20Green%20Tara%20goddess%20Buddhist%20art%20colorful%20traditional%20artwork%20on%20dark%20background%20luxury%20art%20photography%20warm%20golden%20light%20cultural%20heritage%20collectible&width=500&height=500&seq=p_thk001&orientation=squarish",
  },
  {
    id: "thangka-002",
    name: "手繪唐卡 — 財神",
    category: "thangka",
    subcategory: "唐卡",
    desc: "招財納福，事業興旺",
    detail: "財神唐卡是藏傳佛教中最受歡迎的唐卡之一，象徵財富與福氣，是辦公室與家居的最佳擺設。",
    price: 15600,
    img: "https://readdy.ai/api/search-image?query=Tibetan%20thangka%20painting%20wealth%20deity%20Jambhala%20Buddhist%20art%20colorful%20traditional%20artwork%20on%20dark%20background%20luxury%20art%20photography%20warm%20golden%20light%20cultural%20heritage&width=500&height=500&seq=p_thk002&orientation=squarish",
  },
  {
    id: "thangka-003",
    name: "藏傳佛牌 — 蓮花生大士",
    category: "thangka",
    subcategory: "佛牌",
    desc: "降魔護法，智慧加持",
    detail: "蓮花生大士是藏傳佛教的重要祖師，佛牌承載著強大的護法能量，是許多修行者的隨身守護。",
    price: 6800,
    tag: "人氣首選",
    img: "https://readdy.ai/api/search-image?query=Tibetan%20Buddhist%20amulet%20pendant%20Padmasambhava%20gold%20sacred%20charm%20on%20dark%20velvet%20background%20luxury%20jewelry%20product%20photography%20warm%20golden%20light%20spiritual%20protection%20collectible&width=500&height=500&seq=p_thk003&orientation=squarish",
  },
  {
    id: "thangka-004",
    name: "藏傳佛牌 — 白度母",
    category: "thangka",
    subcategory: "佛牌",
    desc: "長壽健康，消業增福",
    detail: "白度母象徵長壽、健康與消業，是祈求健康長壽的最佳守護佛牌，適合送給長輩或自用。",
    price: 5800,
    badge: "新品",
    img: "https://readdy.ai/api/search-image?query=Tibetan%20Buddhist%20amulet%20pendant%20White%20Tara%20gold%20sacred%20charm%20on%20dark%20velvet%20background%20luxury%20jewelry%20product%20photography%20warm%20golden%20light%20spiritual%20protection&width=500&height=500&seq=p_thk004&orientation=squarish",
  },
  {
    id: "thangka-005",
    name: "手繪唐卡 — 釋迦牟尼",
    category: "thangka",
    subcategory: "唐卡",
    desc: "智慧圓滿，心靈歸依",
    detail: "釋迦牟尼佛唐卡是最莊嚴的佛教藝術品之一，象徵智慧與圓滿，是家居供奉與收藏的珍品。",
    price: 22000,
    tag: "限量典藏",
    img: "https://readdy.ai/api/search-image?query=Tibetan%20thangka%20painting%20Shakyamuni%20Buddha%20Buddhist%20art%20colorful%20traditional%20artwork%20on%20dark%20background%20luxury%20art%20photography%20warm%20golden%20light%20cultural%20heritage%20collectible&width=500&height=500&seq=p_thk005&orientation=squarish",
  },
  {
    id: "thangka-006",
    name: "藏傳佛牌套組",
    category: "thangka",
    subcategory: "佛牌",
    desc: "全方位守護，福慧雙修",
    detail: "精選三款藏傳佛牌組合，涵蓋財富、健康與智慧三大面向，是送禮的最佳選擇。",
    price: 16800,
    img: "https://readdy.ai/api/search-image?query=set%20of%20Tibetan%20Buddhist%20amulet%20pendants%20gold%20sacred%20charms%20on%20dark%20velvet%20background%20luxury%20jewelry%20product%20photography%20warm%20golden%20light%20spiritual%20protection%20collectible%20set&width=500&height=500&seq=p_thk006&orientation=squarish",
  },
];

export const categories = [
  {
    id: "all",
    label: "全部商品",
    icon: "ri-apps-2-line",
    color: "#8b6f47",
    bg: "#f5ede0",
  },
  {
    id: "dzi",
    label: "西藏天珠",
    icon: "ri-ancient-gate-line",
    color: "#8b6f47",
    bg: "#f5ede0",
    desc: "千年傳承的守護之珠",
  },
  {
    id: "crystal",
    label: "天然水晶礦石",
    icon: "ri-sparkling-2-line",
    color: "#7a6a9a",
    bg: "#f0edf7",
    desc: "大自然孕育的能量寶石",
  },
  {
    id: "jade",
    label: "翡翠玉石",
    icon: "ri-leaf-line",
    color: "#4a7a52",
    bg: "#eaf2eb",
    desc: "東方文化的吉祥象徵",
  },
  {
    id: "thangka",
    label: "唐卡佛牌",
    icon: "ri-heart-3-line",
    color: "#c9a96e",
    bg: "#faf5ec",
    desc: "信仰與藝術的結合",
  },
];
